export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="openforms-editgrid">\n  ';
 if(ctx.rows.length) { ;
__p += '\n  <div>\n    ';
 ctx.rows.forEach(function(row, rowIndex) { ;
__p += '\n      <div class="utrecht-form-fieldset openforms-editgrid__item">\n        <fieldset class="utrecht-form-fieldset__fieldset utrecht-form-fieldset--html-fieldset">\n          ';
 if (!!ctx.component.groupLabel) { ;
__p += '\n            <legend class="utrecht-form-fieldset__legend utrecht-form-fieldset__legend--html-legend openforms-editgrid__item-heading">\n              ' +
((__t = ( ctx.t(ctx.component.groupLabel, { _userInput: true }) )) == null ? '' : __t) +
' ' +
((__t = ( rowIndex + 1 )) == null ? '' : __t) +
'\n            </legend>\n          ';
 } ;
__p += '\n\n          <div ref="' +
((__t = (ctx.ref.row)) == null ? '' : __t) +
'" class="openforms-form-field-container">\n            ' +
((__t = (row)) == null ? '' : __t) +
'\n          </div>\n\n          ';
 if (ctx.openRows[rowIndex] && !ctx.readOnly) { ;
__p += '\n            <p\n              class="utrecht-button-group utrecht-button-group--openforms-editgrid"\n              ';
 if (ctx.component.removeRow) { ;
__p += 'role="group"';
 } ;
__p += '\n            >\n\n              <button class="utrecht-button utrecht-button--primary-action" ref="' +
((__t = (ctx.ref.saveRow)) == null ? '' : __t) +
'">\n                ' +
((__t = (ctx.t(ctx.component.saveRow || 'Save', { _userInput: true }))) == null ? '' : __t) +
'\n              </button>\n\n              ';
 if (ctx.component.removeRow) { ;
__p += '\n                <button class="utrecht-button utrecht-button--primary-action utrecht-button--danger" ref="' +
((__t = (ctx.ref.cancelRow)) == null ? '' : __t) +
'">\n                  ' +
((__t = (ctx.t(ctx.component.removeRow || 'Cancel', { _userInput: true }))) == null ? '' : __t) +
'\n                </button>\n              ';
 } ;
__p += '\n            </p>\n          ';
 } ;
__p += '\n\n          <!-- Formio needs a div with class="has-error" with inside a div with class="editgrid-row-error" -->\n          <div class="openforms-errors has-error">\n            <div class="editgrid-row-error">' +
((__t = (ctx.errors[rowIndex])) == null ? '' : __t) +
'</div>\n          </div>\n\n        </fieldset>\n      </div>\n\n    ';
 }) ;
__p += '\n  </div>\n  ';
 } ;
__p += '\n\n  ';
 if (!ctx.readOnly && ctx.hasAddButton) { ;
__p += '\n    <p class="utrecht-button-group">\n      <button class="utrecht-button utrecht-button--primary-action" ref="' +
((__t = (ctx.ref.addRow)) == null ? '' : __t) +
'">\n        <i class="' +
((__t = (ctx.iconClass('plus'))) == null ? '' : __t) +
'"></i>\n        ' +
((__t = (ctx.t(ctx.component.addAnother || 'Add Another', { _userInput: true }))) == null ? '' : __t) +
'\n      </button>\n    </p>\n  ';
 } ;
__p += '\n</div>\n';
return __p
}